import axios from "axios";
import baseURL from "./../api";
class PermissionRolesServices {
    getPermissions() {
        return axios.get(`${baseURL}/permissions`);
    }
    


}

export default new PermissionRolesServices();